import FechamentoDeFolha, {
  FinderFechamentosDeFolha,
  RetornoFechamentoDeFolha,
} from 'Interface/FechamentosDeFolha';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'FechamentosDeFolha';

const url = '/fechamentos-de-folha';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarFechamentosDeFolha: construtor.query<
        FinderFechamentosDeFolha,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.fechamentos_de_folha
            ? [
                ...resultado.fechamentos_de_folha.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarFechamentoDeFolha: construtor.query<
        RetornoFechamentoDeFolha,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarFechamentoDeFolha: construtor.mutation<
        FechamentoDeFolha,
        Partial<FechamentoDeFolha>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarFechamentoDeFolha: construtor.mutation<
        FechamentoDeFolha,
        Partial<FechamentoDeFolha> &
          Pick<FechamentoDeFolha, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerFechamentoDeFolha: construtor.mutation<
        FechamentoDeFolha,
        Partial<FechamentoDeFolha> & Pick<FechamentoDeFolha, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarFechamentosDeFolhaQuery,
  useRecuperarFechamentoDeFolhaQuery,
  useAdicionarFechamentoDeFolhaMutation,
  useEditarFechamentoDeFolhaMutation,
  useRemoverFechamentoDeFolhaMutation,
} = apiExtendida;
